import styled, { css } from 'styled-components';
import { lighten } from 'polished';

import 'antd/lib/spin/style/index.css';

const andRadioStyles = `.ant-radio-checked .ant-radio-inner {
  border-color: #398ca1;
  &:hover {
    border-color: #398ca1;
  }
  &:focus {
    border-color: #398ca1;
  }
}

.ant-radio-wrapper:hover .ant-radio,
.ant-radio:hover .ant-radio-inner,
.ant-radio-input:focus + .ant-radio-inner {
  border-color: #398ca1;
}

.ant-radio-group-solid
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #fff;
  background: #398ca1;
  border-color: #398ca1;
}
.ant-radio-group-solid
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
  color: #fff;
  background: #398ca1;
  border-color: #398ca1;
}

.ant-radio-inner::after {
  position: absolute;
  top: 4px;
  left: 4px;
  display: table;
  width: 12px;
  height: 12px;
  background-color: #398ca1;
  border-top: 0;
  border-left: 0;
  border-radius: 8px;
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
  opacity: 0;
  -webkit-transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  content: ' ';
}
.ant-radio-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 22px;
  height: 22px;
  background-color: #fff;
  border-color: #d9d9d9;
  border-style: solid;
  border-width: 1px;
  border-radius: 100px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.ant-radio-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #398ca1;
  border-radius: 50%;
  visibility: hidden;
  -webkit-animation: antRadioEffect 0.36s ease-in-out;
  animation: antRadioEffect 0.36s ease-in-out;
  animation-fill-mode: none;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  content: '';
}`;

export const BreadcumbsContainer = styled.div`
  margin: 0 auto 5px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.headerInline {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
`;

export const BoxButtonDownload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 50px 50px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
  .botao-download {
    background-color: #74a50a !important;
  }

  hr {
    border: solid 1px #b4b4b4;
    opacity: 0.37;
    margin: 30px auto;
  }

  div.boxSelect {
  }

  div.boxButtonSave {
    padding: 60px 0 30px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div.dataPickerContent {
    display: flex;
    padding-top: 33px;
    .ant-input {
      height: 38px;
    }

    .ant-calendar-input-wrap {
      padding: 0px 0px;
      height: 0px;
    }
  }
`;

export const BoxRadios = styled.div`
  ${({ active }) => css`
    padding: 20px 0px;
    border-radius: 3px;
    border: solid 0.5px;
    border-color: ${active ? '#398ca1' : 'transparent'};
    background-color: ${active ? 'rgba(35, 95, 110, 0.16)' : ''};

    .ant-radio-wrapper {
      margin-bottom: 10px;
      display: flex;
      color: #398ca1;
      font-size: 13px;
      font-weight: bold;
      font-variant: tabular-nums;
      line-height: 1.5;
      list-style: none;
      font-feature-settings: 'tnum', 'tnum';
      cursor: pointer;
      span {
        color: ${active ? '#398ca1' : '#898989'};
        font-size: 13px;
        font-weight: bold;
        line-height: 24px;

        display: inline-block;
        letter-spacing: 0px;

        align-items: center;
      }
    }

    ${andRadioStyles}
  `}
`;

export const TitleSection = styled.h4`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  text-align: left;
  color: #74a50a;
  margin-bottom: 20px;

  > span {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    text-align: left;
    color: rgb(153, 153, 153);
    display: block;
    margin-bottom: 20px;
  }
`;

export const ContainerGroups = styled.div`
  margin-bottom: 10px;

  ${andRadioStyles}

  div.todosCheckbox {
    padding-top: 3px;
  }
`;

export const resetButtonStyle = {
  backgroundColor: '#F7F7F7',
  border: 'none',
  color: '#74a50a',
  display: 'flex',
  alignItems: 'center',
  height: '13px',
  float: 'right',
};
